import { render } from "./HEWDashboard.vue?vue&type=template&id=54a1062e&scoped=true"
import script from "./HEWDashboard.vue?vue&type=script&lang=js"
export * from "./HEWDashboard.vue?vue&type=script&lang=js"

import "./HEWDashboard.vue?vue&type=style&index=0&id=54a1062e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a1062e"]])

export default __exports__